// 导入组件
import Vue from "vue";
import Router from "vue-router";
// 登录
import login from "@/views/login";
/**
 * 基础菜单
 */
// 商品管理
import DataBoard from "@/views/DataBoard/index";

// 启用路由
Vue.use(Router);

const routerList = [
  {
    path: "/",
    redirect: "/DataBoard"
  },
  {
    path: "/login",
    name: "登录",
    component: login,
    meta: {
      requireAuth: false
    }
  },
  {
    path: "/DataBoard",
    name: "数据看板",
    component: DataBoard,
    meta: {
      requireAuth: true
    }
  },

  { path: "*", redirect: "/" }
];
// 导出路由
let createRouter = () =>
  new Router({
    mode:'hash',
    routes: routerList,
  });
let menus = [];
let oldMenus = localStorage.getItem("menus")
  ? JSON.parse(localStorage.getItem("menus"))
  : [];

export async function setMenu() {
  oldMenus = localStorage.getItem("menus")
    ? JSON.parse(localStorage.getItem("menus"))
    : [];

  menus = [];
  console.log('尽量了')
  getMenu().then(res => {
    if (res && res.data && res.data.length) {
      menus = setMenus(res.data, menus);
      let obj = {};
      menus = menus.reduce(function(item, next) {
        obj[next.path] ? "" : (obj[next.path] = true && item.push(next));
        return item;
      }, []);
      localStorage.setItem("menus", JSON.stringify(menus));
      if (menus.length != oldMenus.length) {
        menus.forEach(item => {
          let obj = RouterLists.find(it => it.path == item.path);
          if (obj) {
            router.addRoute(obj);
          }
        });
      }
    }
  });
}
function setMenus(menu, list) {
  menu.forEach(item => {
    let obj = RouterLists.find(it => it.path == item.menu_path);
    if (obj) {
      list.push(obj);
    }
    if (item.children && item.children.length > 0) {
      setMenus(item.children, list);
    }
  });
  return list;
}
const router = createRouter();
if (oldMenus.length > 0) {
  oldMenus.forEach(item => {
    let obj = RouterLists.find(it => it.path == item.path);
    if (obj) {
      router.addRoute(obj);
    }
  });
} else {
  setMenu();
}
export function resetRouter() {
  //清空路由的方法
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}
import { getMenu } from "../api/userMG";
import { RouterLists } from "@/router/list.js";

router.beforeEach((to, from, next) => {
  setMenu();
  if (to.matched.length != 0) {
    if (to.meta.requireAuth) {
      // 判断该路由是否需要登录权限
      if (Boolean(localStorage.getItem("userInfo"))) {
        // 通过vuex state获取当前的user是否存在
        next();
      } else {
        next({
          path: "/login",
          query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
        });
      }
    } else {
      if (Boolean(localStorage.getItem("userInfo"))) {
        // 判断是否登录
        if (to.path != "/" && to.path != "/login") {
          //判断是否要跳到登录界面
          next();
        } else {
          /**
           * 防刷新，如果登录，修改路由跳转到登录页面，修改路由为登录后的首页
           */
          next({
            path: "/DataBoard"
          });
        }
      } else {
        next();
      }
    }
  } else {
    next({
      path: "/login",
      query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
    });
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js